import template from './documents-table-body.pug';

export const DocumentsTableBodyComponent = {
  template,
  bindings: {
    filter: '<',
    records: '<',
    checkedIds: '<',
    onCheck: '&',
    gridOptions: '<?',
    onFilterChange: '&'
  },
  controller: class DocumentsTableBodyComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {}

    applyFilter({ filter, searchId }) {
      this.onFilterChange({
        $event: { filter, searchId }
      });
    }

    checkIds({ checkedIds }) {
      this.onCheck({
        $event: { checkedIds }
      });
    }
  }
};
